import { BufferAttribute, BufferGeometry, Mesh, MeshBasicMaterial, type Group, type Material } from 'three'
import type asset from '../../SourceArt/PierContact/floor.json'
import type { CabinetDimensions } from './cabinet'
import { bodyLengthFor } from './cabinet'
let data:typeof asset|undefined
export async function prepareFloorContact():Promise<void>{data??=(await import('../../SourceArt/PierContact/floor.json')).default}
export function addLegFloorContact(d:CabinetDimensions,group:Group,geometries:BufferGeometry[],materials:Material[]):void{
  const positions:number[]=[],uvs:number[]=[],triangles:number[]=[],radius=.041
  for(const sx of [-1,1])for(const sz of [-1,1]){
    const at=positions.length/3,x=sx*(d.width/2-.034),z=sz*(bodyLengthFor(d)/2-.034)
    for(const [xx,zz,u,v] of [[-radius,-radius,0,0],[-radius,radius,0,1],[radius,radius,1,1],[radius,-radius,1,0]]){positions.push(x+xx!,.0008,z+zz!);uvs.push(u!,v!)}
    triangles.push(at,at+1,at+2,at,at+2,at+3)
  }
  drawFloorContact(positions,uvs,triangles,group,geometries,materials)
}
export function addFloorContact(id:string|undefined,d:CabinetDimensions,group:Group,geometries:BufferGeometry[],materials:Material[]):void{
  const t=data?.tables.find(t=>id!==undefined&&t.machineIds.includes(id))
  if(!t||Math.abs(t.width-d.width)>1e-8||Math.abs(t.length-bodyLengthFor(d))>1e-8
    ||Math.abs(t.incline-d.incline)>1e-8||Math.abs(t.frontTopY-d.lockdownBarHeight)>1e-8)return
  drawFloorContact(t.positions,t.uvs,t.triangles,group,geometries,materials)
}
function drawFloorContact(positions:number[],uvs:number[],triangles:number[],group:Group,geometries:BufferGeometry[],materials:Material[]):void{
  const g=new BufferGeometry();g.setAttribute('position',new BufferAttribute(new Float32Array(positions),3));g.setAttribute('uv',new BufferAttribute(new Float32Array(uvs),2));g.setIndex(triangles)
  const m=new MeshBasicMaterial({color:0x000000,opacity:.35,transparent:true,depthWrite:false});m.defines={USE_UV:''}
  m.onBeforeCompile=shader=>{shader.fragmentShader=shader.fragmentShader.replace('#include <opaque_fragment>','diffuseColor.a *= 1.0-smoothstep(0.0,1.0,length(vUv-vec2(0.5))*2.0);\n#include <opaque_fragment>')}
  m.customProgramCacheKey=()=> 'contact-floor-05'
  const mesh=new Mesh(g,m);mesh.name='contact.floor';group.add(mesh);geometries.push(g);materials.push(m)
}
